/**
 * Route middleware guard for ancillaries feature.
 *
 * Validates that the ancillaries feature is enabled before entering the customize step.
 *
 * Redirects back to the trip selection page if the feature is off,
 * since no bookingId is available at this point to redirect to payment.
 */
export default defineNuxtRouteMiddleware(() => {
  const appConfig = useAppConfig();

  if (appConfig.features.oneTimePurchaseAncillaries) return;

  const localePath = useLocalePath();
  return navigateTo(localePath({ name: 'book-select' }));
});
